<template>
  <Picking :id_documento="parseInt($route.params.id_documento)" :num_documento="$route.params.num_documento" />
</template>

<script>
import Picking from '@/components/PICKING/Picking.vue';

export default {
  name: 'PickingView',
  components: {
    Picking,
  },
}
</script>
